module.exports = __webpack_public_path__ + "static/media/terms.71f6568c.svg";